import { apiPatch } from "../../shared/http.js";
import {
  MeResponseSchema,
  PatchMeRequestSchema,
  type MeResponse,
  type PatchMeRequest,
} from "@recipevault/shared";

export async function patchMe(body: PatchMeRequest): Promise<MeResponse> {
  PatchMeRequestSchema.parse(body);
  const raw = await apiPatch<unknown>("/me", body);
  return MeResponseSchema.parse(raw);
}
